import {
  ListItemIcon,
  ListItemText,
  ListItem as MuiListItem,
  Typography,
} from '@mui/material';
import CheckIcon from '@treyd-io/treyd-ui/icons/CheckIcon';
import ForbidIcon from '@treyd-io/treyd-ui/icons/ForbidIcon';
import { ReactNode } from 'react';

export const ListItem = ({
  title,
  subtitle,
  forbid,
}: {
  title: string | ReactNode;
  subtitle?: string;
  forbid?: boolean;
}) => (
  <MuiListItem
    disableGutters
    disablePadding
    alignItems="flex-start"
    sx={{ gap: 2 }}>
    <ListItemIcon sx={{ minWidth: 'auto', marginTop: 0.5 }}>
      {forbid ? <ForbidIcon color="error" /> : <CheckIcon color="success" />}
    </ListItemIcon>
    <ListItemText>
      {typeof title === 'string' ? (
        <Typography variant="body1">{title}</Typography>
      ) : (
        title
      )}

      {subtitle && (
        <Typography variant="body2" color={'text.secondary'}>
          {subtitle}
        </Typography>
      )}
    </ListItemText>
  </MuiListItem>
);
